<template>
  <i class="iconfont"
     @click="select"
     :class="{'icon-weixuanzhong': !status, 'icon-chenggong': status}"></i>
</template>

<script>
export default {
  props: {
    name: {
      type: Number,
      default: 0,
    },
    status: {
      type: Boolean,
    },
  },
  name: 'Selected',
  data() {
    return {
      isSelect: this.status,
    };
  },
  methods: {
    select() {
      // this.isSelect = !this.isSelect;
      this.$emit('select', this.name);
    },
  },
};
</script>

<style scoped>
.iconfont {
  font-size: 16px;
}

.icon-chenggong {
  color: #ff432f;
}
</style>
